import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion/'

import { TableCell } from '@mui/material'
import { ModelAutocompleteField, ModelMenuSelectorField } from '@front/squirtle'

const defaultTableCellProps = {
  align: 'center',
  size: 'small'
}

const Row = ({ row, isSelected, company, ...props }) => {
  const [selectedCompany] = hooks.useGlobalState('persist.selectedCompany')
  const initialRoleFilter = hooks.useCompanyFilter(selectedCompany, { model_name: 'companycontract' })

  const [, setSectionValues] = hooks.useSection(hooks.useSectionPath())
  const onContractChange = useCallback(() => {
    setSectionValues([{ field: 'service', value: null }])
  }, [setSectionValues])

  return (
    <>
      <TableCell {...defaultTableCellProps}>
        <ModelMenuSelectorField
          name={'contract'}
          model_name='companycontract'
          labelKeys={['name']}
          searchMode='search'
          allowNone={false}
          disabled
          selectProps={{ IconComponent: null }}
        />
      </TableCell>
      <TableCell {...defaultTableCellProps}>
        <ModelAutocompleteField
          name={'contract'}
          model_name='companycontract'
          labelKeys={['client_id']}
          searchMode='search'
          allowNone={false}
          autocompleteMutator={q => ({ client_id: { startsWith: q } })}
          config={{
            forced_filter: _.merge({}, initialRoleFilter, { active: 1 }),
            watchers: [initialRoleFilter],
            sort: ['client_id ASC']
          }}
          loadOnFocus
          afterChange={onContractChange}
        />
      </TableCell>
      <TableCell {...defaultTableCellProps}>
        <ModelMenuSelectorField
          name={'service'}
          model_name='companyservice'
          labelKeys={['name']}
          searchMode='search'
          allowNone={false}
          disabled
          selectProps={{ IconComponent: null }}
          loadOnFocus
        />
      </TableCell>
      <TableCell {...defaultTableCellProps}>
        <ModelAutocompleteField
          name={'service'}
          model_name='companyservice'
          labelKeys={['client_id']}
          searchMode='search'
          allowNone={false}
          autocompleteMutator={q => ({ client_id: { startsWith: q } })}
          config={{
            forced_filter: { contract: row?.contract, active: 1 },
            validate_filter: useCallback(() => !!row?.contract, [row?.contract]),
            watchers: [row?.contract],
            sort: ['client_id ASC']
          }}
          loadOnFocus
          disabled={!row?.contract}
        />
      </TableCell>
    </>
  )
}

export default React.memo(Row)
